import { useState } from "react";
import { Box, FormControl, Select, MenuItem, TextField, Avatar, Autocomplete,} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSelector } from "react-redux";
import { IoIosArrowBack } from "react-icons/io";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useForm, Controller } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { BtnLoader } from "../../components/common/Loader";
import { useTheme } from "../../ThemeContext";

const FilterLeave = ({ onApply, onClear, onCancel, username }) => {
  const { isDarkMode } = useTheme();
  const [filters, setFilters] = useState([]);
  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      leaveType: "",
      startDate: null,
      status: "",
      users: null,
    },
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const UserNameOptions = useSelector(
    (state) => state.selectOptions?.UserNameOptions
  );

  const userOptions = UserNameOptions.map((user) => ({
    name: user.name,
    user_id: user.user_id,
    avatar: user.image_url,
    designation: user.designation,
  }));

  // Leave types
  const leaveTypes = [
    "Full Day",
    "Half Day",
    "2 Hrs Permission",
    "Compensation Full Day",
    "Compensation Half Day",
    "Work From Home",
  ];

  const leaveTypeMap = {
    "Full Day": "FULL DAY",
    "Half Day": "HALF DAY",
    "2 Hrs Permission": "2 hrs",
    "Compensation Full Day": "Compensation Full Day",
    "Compensation Half Day": "Compensation Half Day",
    "Work From Home": "Work from Home",
  };

  const handleClear = () => {
    reset({
      leaveType: "",
      startDate: null,
      status: "",
      users: null,
    });
  };

  const onSubmit = (data) => {
    // console.log("user_datas :", data);
    const mappedData = {
      ...data,
      leaveType: leaveTypeMap[data.leaveType] || data.leaveType,
      users: data?.users,
    };
    onApply(mappedData);
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack />
            Filter
          </div>
        </button>
        <div>
          <button
            type="button"
            onClick={handleClear}
            className="R_btn tex-tgba-red clear-filter-btn"
          >
            Clear Filter
          </button>
        </div>
      </div>

      <div className="bg-white px-4 py-3">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* Leave Type Filter */}
            {/* <div className="row mb-3">
                            <div className="col-md-12">
                                <label htmlFor="leaveType" className="form-label">
                                    Leave Type
                                </label>
                                <FormControl fullWidth>
                                    <Controller
                                        name="leaveType"
                                        control={control}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                displayEmpty
                                                inputProps={{ id: "leaveType" }}
                                                renderValue={(selected) =>
                                                    selected ? (
                                                        selected
                                                    ) : (
                                                        <span className="lightText">Select Leave Type</span>
                                                    )
                                                }
                                            >
                                                {leaveTypes.map((type, index) => (
                                                    <MenuItem key={index} value={type}>
                                                        {type}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                            </div>
                        </div> */}

            {/* Date Filters */}
            <div className="row mb-3">
              <div className="col-md-12 mb-4">
                <label className="form-label">Date Of Leave</label>
                <FormControl fullWidth>
                  <Controller
                    name="startDate"
                    control={control}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        format="DD/MM/YYYY"
                        onChange={(date) => field.onChange(date)}
                      />
                    )}
                  />
                </FormControl>
              </div>
              <div className="col-md-12 ">
                <label className="form-label">Status</label>
                <FormControl fullWidth>
                  <Controller
                    name="status"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        displayEmpty
                        inputProps={{ id: "status" }}
                        IconComponent={ExpandMoreIcon}
                        renderValue={(selected) =>
                          selected ? (
                            selected
                          ) : (
                            <span className="lightText">Select Status</span>
                          )
                        }
                      >
                        <MenuItem value="Approved">Approved</MenuItem>
                        <MenuItem value="Declined">Declined</MenuItem>
                        <MenuItem value="Requested">Requested</MenuItem>
                      </Select>
                    )}
                  />
                </FormControl>
              </div>
              {username && (
                <div className="col-md-12 pt-3">
                  <label htmlFor="users" className="form-label mt-2">
                    Employee Name
                    {/* <span className="text-rgbr-red"> *</span> */}
                  </label>
                  <Controller
                    name="users"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <Autocomplete
                        id="users"
                        options={userOptions}
                        getOptionLabel={(option) => option.name || ""}
                        value={
                          userOptions.find((user) => user.user_id === value) ||
                          null
                        }
                        onChange={(event, newValue) => {
                          onChange(newValue ? newValue.user_id : null);
                        }}
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            {...props}
                            className="d-flex align-items-center mb-2"
                            sx={{
                              cursor: "pointer",
                              padding: "10px 16px !important",
                              "&:hover": {
                                backgroundColor: isDarkMode
                                  ? "rgba(255, 255, 255, 0.08) !important"
                                  : "#f5f5f5 !important",
                              },
                              "&[aria-selected='true']": {
                                backgroundColor: isDarkMode
                                  ? "rgba(2, 178, 152, 0.15) !important"
                                  : "rgba(2, 178, 152, 0.08) !important",
                                "&:hover": {
                                  backgroundColor: isDarkMode
                                    ? "rgba(2, 178, 152, 0.25) !important"
                                    : "rgba(2, 178, 152, 0.12) !important",
                                },
                              },
                            }}
                          >
                            <Avatar
                              src={option.avatar}
                              alt={option.name}
                              style={{ marginRight: 8 }}
                            />
                            <div className="d-flex flex-column">
                              <strong>{option.name}</strong>
                              <span>{option.designation}</span>
                            </div>
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Enter Employee Name"
                          />
                        )}
                      />
                    )}
                  />

                  {/* {errors.users && (
                                                <span className="errorMsg">{errors.users.message}</span>
                                              )} */}
                </div>
              )}
            </div>

            {/* Buttons */}
            <div className="bg-white position-absolute w-100 bottom-0 py-3">
              <div className="d-flex justify-content-left mt-3">
                <button
                  type="submit"
                  className="add_btn me-3"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? <BtnLoader /> : "Apply"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  className="cancel_btn"
                  onClick={onCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

export default FilterLeave;
